/**
 * @generated SignedSource<<5bf413ce06d714a6438cb32075a1327c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';
export type AppraisalData = {
  documentId: string;
  ownerId: string;
  review?: string | null;
  seaServiceId: string;
};
export type AppraisalMutationsFormCreateMutation$variables = {
  connections: ReadonlyArray<string>;
  data: AppraisalData;
};
export type AppraisalMutationsFormCreateMutation$data = {
  readonly createAppraisal: {
    readonly node: {
      readonly 'id': string;
      readonly ' $fragmentSpreads': FragmentRefs<'AppraisalFragmentsOneAppraisal'>;
    } | null;
  };
};
export type AppraisalMutationsFormCreateMutation = {
  response: AppraisalMutationsFormCreateMutation$data;
  variables: AppraisalMutationsFormCreateMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'connections',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'data',
    },
    v2 = [
      {
        kind: 'Variable',
        name: 'data',
        variableName: 'data',
      },
    ],
    v3 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v4 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null,
    };
  return {
    fragment: {
      argumentDefinitions: [v0 /*: any*/, v1 /*: any*/],
      kind: 'Fragment',
      metadata: null,
      name: 'AppraisalMutationsFormCreateMutation',
      selections: [
        {
          alias: null,
          args: v2 /*: any*/,
          concreteType: 'AppraisalEdge',
          kind: 'LinkedField',
          name: 'createAppraisal',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Appraisal',
              kind: 'LinkedField',
              name: 'node',
              plural: false,
              selections: [
                v3 /*: any*/,
                {
                  args: null,
                  kind: 'FragmentSpread',
                  name: 'AppraisalFragmentsOneAppraisal',
                },
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [v1 /*: any*/, v0 /*: any*/],
      kind: 'Operation',
      name: 'AppraisalMutationsFormCreateMutation',
      selections: [
        {
          alias: null,
          args: v2 /*: any*/,
          concreteType: 'AppraisalEdge',
          kind: 'LinkedField',
          name: 'createAppraisal',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Appraisal',
              kind: 'LinkedField',
              name: 'node',
              plural: false,
              selections: [
                v3 /*: any*/,
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'review',
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'Document',
                  kind: 'LinkedField',
                  name: 'document',
                  plural: false,
                  selections: [
                    v3 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'urls',
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'xlarge_urls',
                      storageKey: null,
                    },
                  ],
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'Profile',
                  kind: 'LinkedField',
                  name: 'owner',
                  plural: false,
                  selections: [v3 /*: any*/],
                  storageKey: null,
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'SeaService',
                  kind: 'LinkedField',
                  name: 'seaService',
                  plural: false,
                  selections: [
                    v3 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'start',
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'end',
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Duty',
                      kind: 'LinkedField',
                      name: 'duty',
                      plural: false,
                      selections: [v3 /*: any*/, v4 /*: any*/],
                      storageKey: null,
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'Vessel',
                      kind: 'LinkedField',
                      name: 'vessel',
                      plural: false,
                      selections: [
                        v4 /*: any*/,
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'image',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'cnISO',
                          storageKey: null,
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'countryName',
                          storageKey: null,
                        },
                        v3 /*: any*/,
                      ],
                      storageKey: null,
                    },
                  ],
                  storageKey: null,
                },
              ],
              storageKey: null,
            },
            {
              alias: null,
              args: null,
              filters: null,
              handle: 'appendNode',
              key: '',
              kind: 'LinkedHandle',
              name: 'node',
              handleArgs: [
                {
                  kind: 'Variable',
                  name: 'connections',
                  variableName: 'connections',
                },
                {
                  kind: 'Literal',
                  name: 'edgeTypeName',
                  value: 'AppraisalEdge',
                },
              ],
            },
          ],
          storageKey: null,
        },
      ],
    },
    params: {
      cacheID: 'e4642a4148c12db779877583c4ee94a6',
      id: null,
      metadata: {},
      name: 'AppraisalMutationsFormCreateMutation',
      operationKind: 'mutation',
      text: 'mutation AppraisalMutationsFormCreateMutation(\n  $data: AppraisalData!\n) {\n  createAppraisal(data: $data) {\n    node {\n      id\n      ...AppraisalFragmentsOneAppraisal\n    }\n  }\n}\n\nfragment AppraisalFragmentsOneAppraisal on Appraisal {\n  id\n  review\n  document {\n    id\n    urls\n    xlarge_urls\n  }\n  owner {\n    id\n  }\n  seaService {\n    id\n    start\n    end\n    duty {\n      id\n      name\n    }\n    vessel {\n      name\n      image\n      cnISO\n      countryName\n      id\n    }\n  }\n}\n',
    },
  };
})();

(node as any).hash = '9c939a844054461d09f714c13e6fea71';

export default node;
